import React from 'react';
import { Loader } from '@progress/kendo-react-indicators';
import styles from './style.module.scss';

export function FpLoading() {
  return (
    <div className={styles.loader}>
      <Loader type="converging-spinner" size="large" />
    </div>
  );
}
